
<div class="app-root-wrapper">
  <!--This is to avoid reload during acquireTokenSilent() because of hidden iframe -->
  @if (!isIframe) {
  <router-outlet></router-outlet>
  }
</div>
<!-- <button mat-button (click)="getAccessToken()">Get Access Token</button> -->
